import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ShortBody } from 'components/Typography';
import { SizedCaptions } from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MyguaranteesBloc/style';
import {
  getVimeoThumbnailSrcSelector,
  getIsLoadingVimeoThumbnailSrcSelector,
  getVimeoThumbnailSrcErrorMessageSelector,
} from 'store/global/selectors';
import { getVimeoThumbnailSrc } from 'store/global/actions';
import VimeoThumbnail from 'components/VimeoThumbnail';

const TabPanelContent = ({ title, body, videoId, ...otherProps }: any) => {
  useEffect(() => {
    otherProps.getVimeoThumbnailSrc(videoId);
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ShortBody weight="bold" color="#0075C9">
            {title}
          </ShortBody>
        </Grid>
        <Grid item xs>
          <SizedCaptions weight="400">{body}</SizedCaptions>
        </Grid>
        {videoId && (
          <Grid item xs={4}>
            <VimeoThumbnail
              vimeoThumbnailSrc={otherProps.vimeoThumbnailSrc}
              videoId={videoId}
              isLoadingThumbnail={otherProps.isLoadingVimeoThumbnailSrc}
              thumbnailErrorMessage={otherProps.vimeoThumbnailSrcErrorMessage}
              title={title}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    vimeoThumbnailSrc: string;
    isLoadingVimeoThumbnailSrc: string;
    vimeoThumbnailSrcErrorMessage: string;
  }
>({
  vimeoThumbnailSrc: getVimeoThumbnailSrcSelector,
  isLoadingVimeoThumbnailSrc: getIsLoadingVimeoThumbnailSrcSelector,
  vimeoThumbnailSrcErrorMessage: getVimeoThumbnailSrcErrorMessageSelector,
});

const mapDispatchToProps = {
  getVimeoThumbnailSrc,
};

export default connect(mapStateToProps, mapDispatchToProps)(TabPanelContent);
